
import Blog from '~/components/Common/Blog'
import Content from '~/components/Common/Blog/BlogContent/ThemeType'

export default {
    components: { Blog, Content },
}
